<template>
  <div id="app">
    <router-view/>
    <vue-snotify/>
  </div>
</template>

<script>
export default {
  name: 'App',
  metaInfo: {
    titleTemplate (titleChunk) {
      const title = process.env.VUE_APP_NAME

      return titleChunk ? `${titleChunk} - ${title}` : title
    }
  }
}
</script>
